import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '@/stores/theme';

interface ThemeToggleProps {
  /** Which account the preference should be persisted to. Defaults to staff. */
  context?: 'staff' | 'portal';
}

export function ThemeToggle({ context = 'staff' }: ThemeToggleProps) {
  const { theme, isLoading, saveTheme, savePortalTheme } = useThemeStore();
  const isLight = theme === 'light';

  const handleClick = () => {
    const next = isLight ? 'dark' : 'light';
    const persist = context === 'portal' ? savePortalTheme : saveTheme;
    void persist(next);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isLoading}
      aria-label={isLight ? 'Ativar tema escuro' : 'Ativar tema claro'}
      title={isLight ? 'Tema claro' : 'Tema escuro'}
      className="inline-flex items-center justify-center rounded-lg p-2 text-ds-text-secondary transition-colors hover:bg-ds-surface2 hover:text-ds-text-primary disabled:opacity-50"
    >
      {isLight ? (
        <Sun className="h-5 w-5" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
    </button>
  );
}
